import React from "react"
import styles from './Slices.module.css'
import { SliceItem } from "./SliceItem"

export const Slices = (props) => {
    const renderSlices = () => {
        let slices = []
        props.songMap.forEach((value, key) => {
            slices.push(<SliceItem key={key} slice={key} value={value} handleClick={props.handleClick} />)
        })
        return slices
    }

    return <div className={styles.slicesContainer}>
        {props.songMap && renderSlices()}
    </div>
}